module.exports = __webpack_public_path__ + "static/media/backgroundHorizontal.25f911e1.jpg";